import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gy33y47y5m: FaireBrandEntity = {
  token: "b_gy33y47y5m",
  type: "brand",
  name: "Fashion City",
  avatarUrl:
    "https://cdn.faire.com/fastly/80a33f552d8124a9d4d32096f49669be07b219f9bbd331b9bba58e535e0a9d8d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/548809dbaf12a0f8d20bdcfa871dbfdb48e2f83cc1378015dbbac8917d27ed1d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/80a33f552d8124a9d4d32096f49669be07b219f9bbd331b9bba58e535e0a9d8d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/548809dbaf12a0f8d20bdcfa871dbfdb48e2f83cc1378015dbbac8917d27ed1d.jpeg",
  location: "Farmingdale, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 1959,
  isTopShop: true,
  isInsider: true,
  description:
    "\nFASHION CITY is one of the leading fashion accessories wholesalers in New York City. We specialize in manufacture the highest quality, unique designs, premium marketing plans, and competitive prices for customers.\n\nOur goal is to satisfy our customers by providing quality items and provide excellent customer service.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:01.919Z",
    importedBy: "entity-db-cli",
  },
};
